import axios from 'axios'
import { storeToRefs } from 'pinia'
import useAuthStore from '@/store/auth'

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_SECURITY,
  // baseURL: 'http://localhost:5001/api/',
})

axiosIns.interceptors.request.use(
  config => {
    const { accessTokenFlow } = storeToRefs(useAuthStore())

    if (accessTokenFlow.value) return { ...config, headers: { Authorization: `Bearer ${accessTokenFlow.value}` } }
    return config
  },
  error => Promise.reject(error),
)

export default axiosIns
